import { FieldValueObject, FieldValue, Field, setFieldValue, isFieldValueObject } from './field';

// only constant since adding new property isn't required
export class FieldObjectCst extends Field<FieldValueObject> {
	readonly fields: Field<FieldValue>[];
	readonly fieldNames: string[];
	constructor(
		name: string,
		fields: Field<FieldValue>[]
	) {
		super(false, 'objectCst', name);
		this.fields = fields;
		this.fieldNames = this.fields.map(field => field.name);
	}

	value() {
		const value: FieldValueObject = {};
		let isFieldValue = false;
		for (const field of this.fields) {
			const fieldValue = field.value();
			if (fieldValue !== undefined) {
				setFieldValue(field.name, fieldValue, value);
				isFieldValue = true;
			}
		}
		return isFieldValue ? value : undefined;
	}

	collectVarValue(object: FieldValueObject) {
		for (const field of this.fields) {
			if (field.isVar) {
				field.collectVarValue(object);
			}
		}
	}

	getField(name: string) {
		return this.fields.find(field => field.name === name);
	}

	extractVarValue() {
		const value: FieldValueObject = {};
		this.collectVarValue(value);
		return value;
	}

	setValue(value: FieldValue) {
		if (value !== undefined && isFieldValueObject(value)) {
			const valueObject = <FieldValueObject> value;
			for (const fieldName of Object.getOwnPropertyNames(valueObject)) {
				const field = this.getField(fieldName);
				if (field) {
					field.setValue(valueObject[fieldName]);
				}
			}
			return;
		}
		throw new Error(`unable to set value; expected object, but found ${ JSON.stringify(value) }`);
	}
}
